module.exports = __webpack_public_path__ + "static/img/blueberrypomegranate_th.1e609b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/cans/blueberrypomegranate_th.png
// module id = 9roJ
// module chunks = 0